import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Icon,
  Tooltip,
} from 'antd';

import {
  REGEX_TAG_PARSE,
  UNKNOWN_TAG_TIPS,
} from '../../../costants';


const UserTag = ({
  text,
  membersByUserId,
}) => {
  const userData = text.split(REGEX_TAG_PARSE);
  const member = _.get(membersByUserId, [userData[1], 'user'], {});
  return (
    _.isEmpty(member) ? (
      <Tooltip
        title={UNKNOWN_TAG_TIPS}
      >
        <span
          className="message-item-tag disabled"
        >
          <Icon type="user" className="message-item-tag-icon" />
          {`${userData[2]} ${userData[3]}`}
        </span>
      </Tooltip>
    ) : (
      <span
        className="message-item-tag"
      >
        <Icon type="user" className="message-item-tag-icon" />
        {`${member.firstName} ${member.lastName}`}
      </span>
    )
  );
};

UserTag.propTypes = {
  text: PropTypes.string,
  membersByUserId: PropTypes.object,
};

UserTag.defaultProps = {
  text: '',
  membersByUserId: {},
};

export default UserTag;



// WEBPACK FOOTER //
// ./src/modules/messaging/components/ChannelDetail/Message/UserTag.js